// extracted by mini-css-extract-plugin
export default {"wrapLabel":"Dobavljaci_wrapLabel__hqmAM"};